import { computed } from 'vue';

/**
 * Feed 首屏失败展示：network 全视口覆盖；server 列表区内嵌。
 * @param {object} storeRefs storeToRefs 结果，需含 listLoading / loadingMore / listFetchError
 * @param {import('vue').Ref<Array>|import('vue').ComputedRef<Array>} cardsRef
 */
export function useFeedNetworkPresentation(storeRefs, cardsRef) {
  const isFirstScreenFetchIdle = computed(() => {
    if (storeRefs.listLoading?.value || storeRefs.loadingMore?.value) return false;
    if (cardsRef.value.length) return false;
    return true;
  });

  const showFeedNetworkError = computed(
    () => isFirstScreenFetchIdle.value && storeRefs.listFetchError?.value === 'network'
  );

  const showFeedFetchError = computed(
    () => isFirstScreenFetchIdle.value && storeRefs.listFetchError?.value === 'server'
  );

  const networkErrorRetrying = computed(() => Boolean(storeRefs.listLoading?.value));
  const feedFetchErrorRetrying = networkErrorRetrying;

  return {
    showFeedNetworkError,
    showFeedFetchError,
    networkErrorRetrying,
    feedFetchErrorRetrying,
  };
}
